<template>
	<div class="about_us">
		<div class="aus_pc pt_90" v-if="!isPhone">
			<pageBanner :imgurl="banner"></pageBanner>
			<location lone="关于交控" v-if="tabarr.length" :ltwo="tabarr[tabact].title"></location>
			<div class="con_wrap">
				<div class="con_box flex1">
					<div class="con_left">
						<tabson :titobj="tabtit" :tablist="tabarr" :actIndex="tabact" @tab-change="tabChange"></tabson>
						<br>
						<contact></contact>
					</div>
					<div class="con_right">
						<div class="tfm_tit" v-if="tabarr.length">{{ tabarr[tabact].title }}</div>
						<div class="rc_data">
							<div class="video_box">
								<video v-if="rcdata.file" :src="staticImg + rcdata.file" :poster="staticImg + rcdata.image"
									controls></video>
							</div>
							<div class="mt_20 img_auto" style="padding: 20px;" :style="{ backgroundColor: bgcolor }" v-html="rcdata.content"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="aus_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="关于集团"></Header2>
			<pageBanner2 :imgurl="banner"></pageBanner2>
			<div class="ph_tab_box flex3">
				<div class="ph_tab_item" v-for="(item, index) in tabarr" :key="index" @click="tabChange(index)">
					<span :class="tabact == index ? 'ph_act1' : ''">{{ item.title }}</span>
				</div>
			</div>
			<div class="ph_acdata">
				<div class="video_box">
					<video v-if="rcdata.file" :src="staticImg + rcdata.file" :poster="staticImg + rcdata.image" controls></video>
				</div>
				<div class="mt_20" style="padding: 0.4rem;" :style="{ backgroundColor: bgcolor }" v-html="rcdata.content"></div>
			</div>
			<br><br>
		</div>
	</div>
</template>

<script>

import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			tabtit: {
				title1: '关于交控',
				title2: 'About Jiaokong',
			},
			tabact: 0,
			tabarr: [],
			rcdata: {},
			staticImg: this.$staticImg,
			isctro: false,
			banner: '',
			isPhone: this.$isMobile,
			bgcolor: '#fcfcfc',
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList);
		this.tabact = Number(this.$route.query.sort - 1);
		this.about();
		this.$forceUpdate();
	},
	watch: {
		$route(to, from) {
			this.tabact = Number(this.$route.query.sort - 1);
			this.about();
		},
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal);
				this.about();
			}
		},
	},
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/aboutUs?sort=1') {
					this.banner = this.$staticImg + arr[i].image;
					this.tabarr = arr[i].son;
				}
			}
		},
		tabChange(index) {
			this.$router.push('/aboutUs?sort=' + (index + 1));
		},
		// 集团简介
		async about() {
			var tpnum = '';
			if (this.tabarr.length) {
				if (this.tabarr[this.tabact].title == '企业简介') tpnum = 1;
				if (this.tabarr[this.tabact].title == '集团荣誉') tpnum = 2;
				if (this.tabarr[this.tabact].title == '组织架构') tpnum = 3;
				if (this.tabarr[this.tabact].title == '下属企业') tpnum = 4;
				const res = await this.$api.about({
					type: tpnum,
				});
				if (res.code == 1) {
					this.rcdata = res.data;
					if (res.data.color != null && res.data.color != '') {
						this.bgcolor = res.data.color;
					}
				}
			}
		},
	}
}
</script>

<style lang="scss">
.about_us {
	.aus_pc {
		.con_wrap {
			.con_box {
				min-width: 1000px;

				.con_right {
					.rc_data {
						.video_box {
							video {
								width: 100%;
								height: 548px;
								object-fit: cover;
							}
						}

						p {
							line-height: 2 !important;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1600px) {
		.aus_pc {
			.con_wrap {
				.con_box {
					.con_right {
						.rc_data {
							.video_box {
								video {
									height: 500px;
								}
							}

							p {
								line-height: 2 !important;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		.aus_pc {
			.con_wrap {
				.con_box {
					.con_right {
						.rc_data {
							.video_box {
								video {
									height: 480px;
								}
							}

							p {
								line-height: 2 !important;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1300px) {
		.aus_pc {
			.con_wrap {
				.con_box {
					.con_right {
						.rc_data {
							.video_box {
								video {
									height: 460px;
								}
							}

							p {
								line-height: 2 !important;
							}
						}
					}
				}
			}
		}
	}

	.aus_ph {
		padding-top: 1.23rem;
		padding-bottom: 80px;
        .ph_acdata{
            img{
                max-width: 100% !important;
                height: auto !important;
            }
        }
	}
}
</style>